import { Injectable } from '@angular/core';
import { Card } from '../models/card.model';
import { LoggingService } from './LoggingService.service';
import { DataServices } from './data.services';

@Injectable()
export class CardsService{

  cards: Card[] = [];

  constructor(private loggingService: LoggingService, private dataServices: DataServices){}

  getCards() {
    return this.dataServices.getCards();
 }

 setCards(cards: Card[]) {
    this.cards =  cards;
    //this.loggingService.logMessage('cards LIST SIZE: ' + cards.length);
 }

}
